import { sendMessage } from '../widgetMessaging';
import { widgetActions } from '../widgetSlice';

export enum NotificationType {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    SUCCESS = 'success',
}

export type EventShowNotification = {
    type: NotificationType;
    title?: string;
    message: string;
};

export const showMapNotification = (type: NotificationType, message: string, title?: string) => {
    sendMessage(widgetActions.showMapNotification({ type, message, title }));
};
